import { render, staticRenderFns } from "./ReviewerAssesment.vue?vue&type=template&id=d649dbe6&scoped=true&"
import script from "./ReviewerAssesment.vue?vue&type=script&lang=ts&"
export * from "./ReviewerAssesment.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewerAssesment.vue?vue&type=style&index=0&id=d649dbe6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d649dbe6",
  null
  
)

component.options.__file = "ReviewerAssesment.vue"
export default component.exports